import { AggregationField } from '../aggregation/fields/aggregationFieldPortfolio';
import { PortfolioSummaryDrillDown } from '../store/instances/component/PortfolioSummaryComponentState';
import { useSelector } from 'react-redux';
import State from 'store/State';
import {
    selectPortfolioSummaryAggregatedData,
    selectPortfolioSummaryAggregatedDataDrillDown,
} from '../store/data/selectors';

export const useTreemapAggregatedData = (
    aggregationField: AggregationField,
    drillDown?: PortfolioSummaryDrillDown
) =>
    useSelector((state: State) => {
        if (drillDown) {
            return selectPortfolioSummaryAggregatedDataDrillDown(
                state,
                aggregationField,
                drillDown
            );
        }

        return selectPortfolioSummaryAggregatedData(state, aggregationField);
    });
